import * as i0 from "@angular/core";
var ConsentScopesService = /** @class */ (function () {
    function ConsentScopesService() {
        this.consentScopes = [
            "user.read",
            "openid",
            "profile"
        ];
    }
    ConsentScopesService.prototype.getConsentScopes = function () {
        return this.consentScopes;
    };
    ConsentScopesService.ngInjectableDef = i0.defineInjectable({ factory: function ConsentScopesService_Factory() { return new ConsentScopesService(); }, token: ConsentScopesService, providedIn: "root" });
    return ConsentScopesService;
}());
export { ConsentScopesService };
